import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, ViewChild, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IWaterSupplyZone, IWaterSupplyZoneGeo } from '../water-supply-zone.model';
import { WaterSupplyZoneService } from '../water-supply-zone.service';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { KeyValueFormComponent } from 'src/app/shared/components/forms/key-value-form/key-value-form.component';
import { WaterSupplyZoneGeoService } from '../water-supply-zone-geo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { ScreenService } from 'src/app/core/services/screen.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { CardComponent } from "../../../shared/components/cards/card/card.component";
import { MyButtonComponent } from "../../../shared/components/buttons/my-button/my-button.component";
import { PageComponent } from "../../../layout/pages/page/page.component";


@Component({
  selector: 'app-wsz-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    EditableCardComponent,
    TextFieldComponent,
    KeyValueFormComponent,
    GoogleMapsModule,
    CardComponent,
    MyButtonComponent,
    PageComponent
],
  templateUrl: './dettaglio-interserzioni-page.component.html',
  styleUrl: './dettaglio-interserzioni-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DettaglioIntersezioniPageComponent {
  @Input() id = '0';
  detailLoaded =false
  dati : any;
  editablePolygons: google.maps.Polygon[] = [];
  resultEdit=new Array()
  form: FormGroup;
  model: WritableSignal<IWaterSupplyZoneGeo | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
    center: google.maps.LatLngLiteral = { lat: 41.8992, lng: 12.5450 };
    zoom = 5.3;
    options: google.maps.MapOptions = {
      mapTypeId: 'roadmap',
  /*     tilt: 0,
      clickableIcons: false,
      disableDefaultUI: true,
      disableDoubleClickZoom: true,
      zoomControl: true,
      scrollwheel: false,
      gestureHandling: 'auto',
      keyboardShortcuts: false,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,  */
    };
  constructor(
    private readonly fb: FormBuilder,
    public readonly service: WaterSupplyZoneGeoService,
    private route: ActivatedRoute,
    private screen: ScreenService,
    private router:Router,
    private ref:ChangeDetectorRef,
    private dialogService: DialogService,
    @Inject(SnackbarService) protected  readonly snackbar: SnackbarService,
    private cdr : ChangeDetectorRef
    
  ) {

      this.form = this.fb.group({
        nome: new FormControl('', [Validators.required]),
        myGeoJson: new FormControl('', ),
      });
  }
  ngOnInit(){
    this.route.paramMap.subscribe(params => {
     var id = params.get("id"); 
     if(id){
      this.service.getById(id).subscribe(el=>{

         this.dati=el
         this.detailLoaded=true; 
         this.form.get("nome")?.setValue(this.dati?.nome)
         this.loadGeoJson(this.dati?.featureMultiPolygon, true)
         if(this.dati.isOverLap && Array.isArray(this.dati.listIsOverLapWsz)){
          this.dati.listIsOverLapWsz.forEach((intersecId:any) => {
            console.log(intersecId)
            this.service.getById(intersecId).subscribe((el:any)=>{
     
              this.loadGeoJson(el?.featureMultiPolygon!)
            })
          });
         }
         this.cdr.detectChanges()
        })
     }

    })
  }

    customActionClick:Function=(el:any)=>{
    

  
    }

    polygonToGeoJSON(polygon: google.maps.Polygon): GeoJSON.Feature<GeoJSON.Polygon> {
      const path = polygon.getPath();
      const coordinates: [number, number][] = [];
    
      for (let i = 0; i < path.getLength(); i++) {
        const latLng = path.getAt(i);
        coordinates.push([latLng.lng(), latLng.lat()]);
      }
    
      // Chiudi il poligono se serve
      if (
        coordinates.length > 0 &&
        (coordinates[0][0] !== coordinates[coordinates.length - 1][0] ||
         coordinates[0][1] !== coordinates[coordinates.length - 1][1])
      ) {
        coordinates.push(coordinates[0]);
      }
    
      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coordinates]
        },
        properties: {}
      };
    }
    
    

    onSendClick(){

      this.getEditablePolygons().forEach(element => {
        console.log(element)
      this.resultEdit.push(this.polygonToGeoJSON(element))
      });
    
      this.route.paramMap.subscribe(params => {
        var id = params.get("id"); 
        if(id){
          const mapInstance = this.map.googleMap;

          if(mapInstance){
            
    
              this.form.get("myGeoJson")?.setValue( {
                type: "FeatureCollection",
                features: this.resultEdit
              })
              this.service.modifyWsz(id!, this.form.value).subscribe((ell:any)=>{
                this.snackbar.success("Dati salvati con successo")
                
                this.form.reset()
                this.router.navigate(['water-supply-zone/lista'])
              })
     
          }
        }
      })
  
    }

  formatDateCreation(dateCreation : string){
    const isoString =dateCreation;
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate

  }

  getGestore(){
    var denominazione = ''
    if(Array.isArray(this.dati?.idAreraGestore)){
      this.dati?.idAreraGestore.forEach((element:any) => {
        if(element.denominazione){
          denominazione= element.denominazione
        }
      });
    }
    return denominazione
  }
  getEditablePolygons(): google.maps.Polygon[] {
    return this.editablePolygons.filter(poly => poly.getEditable());
  }
  loadGeoJson(data: any, canEdit = false) {
    this.waitForMapInit().then(() => {
      if (!this.map?.googleMap) return;
      const mapInstance = this.map.googleMap;
  
      if (this.isValidJSON(data)) {
        data = JSON.parse(data);
      }
  
      // Add new GeoJSON data
      const newFeatures = mapInstance.data.addGeoJson(data);
  
      // Set style for all features
      mapInstance.data.setStyle((feature) => {
        return {
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 1,
        };
      });
  
      // If editability is required, extract geometry and create editable polygons
      if (canEdit) {
        mapInstance.data.forEach((feature) => {

          const geometry = feature.getGeometry();
          if (!geometry) return;
  
          const type = geometry.getType();
  
          if (type === 'Polygon') {
            const polygon = geometry as google.maps.Data.Polygon;
            const paths = polygon.getArray().map((linearRing) =>
              linearRing.getArray().map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }))
            );
  
            var polygonCreated = new google.maps.Polygon({
              paths,
              strokeColor: 'green', 
              strokeOpacity: 0.8,
              strokeWeight: 1,
              fillColor:  'green', 
              fillOpacity: 0.35,
              editable: true,
              map: mapInstance,
            });
            this.editablePolygons.push(polygonCreated);
            mapInstance.data.remove(feature);
         
          } else if (type === 'MultiPolygon') {
            const multiPolygon = geometry as google.maps.Data.MultiPolygon;
            multiPolygon.getArray().forEach((polygon) => {
              const paths = polygon.getArray().map((linearRing) =>
                linearRing.getArray().map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }))
              );
  
              var polygonCreated = new google.maps.Polygon({
                paths,
                strokeColor: 'green',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: 'green',
                fillOpacity: 0.35,
                editable: true,
                map: mapInstance,
              });
              this.editablePolygons.push(polygonCreated);
            });
           
            mapInstance.data.remove(feature);
            
          }
        });
      }


          //inizio prova
    const bounds = new google.maps.LatLngBounds();

    newFeatures.forEach((feature: any) => {
      const geometry = feature.getGeometry();
 
      geometry.forEachLatLng((latLng: google.maps.LatLng) => {
        bounds.extend(latLng);
      });
    });
 
 
    const center = bounds.getCenter();
    this.center = {
      lat: center.lat(),
      lng: center.lng(),
    };
 
     this.zoom = 10;
       this.ref.detectChanges()
       //fine prova

    });
  }
  
  
  

   waitForMapInit(){
    return new Promise((resolve) => {
      const checkMap = setInterval(() => {
        if (this.map && this.map.googleMap) {
          clearInterval(checkMap);
          resolve(null);
        }
      }, 100); 
    });
  };

  addIntersectionWsz(){

  }

  isValidJSON(str:any){
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
}
